<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="功能">
        <el-input v-model="formLabelAlign.func_desc" />
      </el-form-item>
      <el-form-item label="文件名">
        <el-input v-model="formLabelAlign.file_name" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { createOtaConfig } from '@/api/stwert.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        func_desc: '',
        file_name: ''
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async sumbit() {
      if (this.formLabelAlign.func_desc === '') {
        this.$message({
          message: '请填写功能',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.file_name === '') {
        this.$message({
          message: '请填写文件名',
          type: 'error'
        })
        return
      }
      const data = await createOtaConfig(this.formLabelAlign)
      this.$message({
        message: '添加配置成功',
        type: 'success'
      })
      this.$emit('updatatot')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
